export default [
    // {
    //     path: "/integral",
    //     name: "integral",
    //     component: () => import("@/views/integral/index.vue"),
    //     meta: {
    //       title: "积分兑券",
    //       showName: true,
    //     },
    //   },
      {
        path: "/exchange",
        name: "exchange",
        component: () => import("@/views/integral/exchange.vue"),
        meta: {
          title: "我的卡包",
        },
      },
      {
        path: "/success",
        name: "success",
        component: () => import("@/views/integral/success.vue"),
        meta: {
          title: "兑换成功",
        },
      },
      {
        path: "/integralExplain",
        name: "integralExplain",
        component: () => import("@/views/integral/explain.vue"),
        meta: {
          title: "惠民绿色积分-使用说明",
        },
      },
      {
        path: "/integral",
        name: "integral",
        component: () => import("@/views/integral/hr-wx/home.vue"),
        meta: {
          title: "移动积分兑券",
          showName: true,
        },
      },
      {
        path: "/h5-integral",
        name: "h5Integral",
        component: () => import("@/views/integral/hr-h5/home.vue"),
        meta: {
          title: "移动积分兑券",
          showName: true,
        },
      },
      {
        path: "/h5-record",
        name: "h5Record",
        component: () => import("@/views/integral/hr-h5/exchange-records.vue"),
        meta: {
          title: "移动积分兑券",
        },
      },
      {
        path: "/hr-record",
        name: "hrRecord",
        component: () => import("@/views/integral/hr-wx/exchange-records.vue"),
        meta: {
          title: "移动积分兑券",
        },
      },
      {
        path: "/h5-faq",
        name: "h5Faq",
        component: () => import("@/views/integral/hr-h5/faq.vue"),
        meta: {
          title: "常见问题",
        },
      },
]